<div class="cookie-consent" *ngIf="showPopup">
    <p>We use cookies to improve your experience. By using our site, you agree to our use of cookies.</p>
    <button class="accept-btn" (click)="acceptCookies()">Accept</button>
    <button class="reject-btn" (click)="rejectCookies()">Reject</button>
</div>